import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
    closeButton: {
        color: theme.palette.grey[500],
    },
})


export const HeaderWithCloseButton = withStyles(styles)((props) => {
    const {children, classes, onClose, titleId, ...other} = props;
    return <DialogTitle id={titleId} disableTypography {...other}>
        <Grid container justifyContent={'space-between'} alignItems={"center"}>
                {children}
            <Grid item>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </Grid>
        </Grid>
    </DialogTitle>
})
